





































import {Component, Prop, Watch} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {OrbitTransactionCollection} from '@/model/collection/OrbitTransactionCollection'
import DappDetailedOrbitContentFilter from './DappDetailedOrbitContentFilter.vue'
import DappDetailedOrbitScrollableTable from './DappDetailedOrbitScrollableTable.vue'
import PoweredBy, {PoweredByItem} from '@/components/PoweredBy.vue'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {$} from '@/facade'
import {OrbitHelper} from '@/helpers/OrbitHelper'

@Component({
  components: {
    DappDetailedOrbitContentFilter,
    DappDetailedOrbitScrollableTable,
    PoweredBy,
  },
})
export default class DappDetailedOrbitContent extends MixinScreenSize {
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection

  rounds: number[] = []

  displayedRound: number | null = null
  activeRound: number | null = null
  displayedItems: OrbitProject[] = []

  transactionCountMap: Record<
    number,
    {
      total: string
      your: string
    }
  > = {}

  mounted() {
    if (!this.isOrbitEnabled) return
    const tempRounds = this.orbitProjectCollection.items
      .map(item => item.orbitRound?.round)
      .filter(round => round !== null && round !== undefined)

    // Normalize to number to avoid duplicates like "10" vs 10
    const normalizedRounds = tempRounds
      .map(round => Number(round))
      .filter(round => !Number.isNaN(round))

    const uniqueRounds = [...new Set(normalizedRounds)]
    const uniqueRoundsSorted = uniqueRounds.sort((a, b) => b - a)
    const filteredRounds = uniqueRoundsSorted.filter(round => round !== 0)

    this.rounds = filteredRounds
    this.displayedRound = this.rounds[0]

    this.displayedItems = this.orbitProjectCollection.items.filter(item => {
      const itemRound = item.orbitRound?.round
      return itemRound !== null && itemRound !== undefined
        ? Number(itemRound) === this.displayedRound
        : false
    })

    this.populateResources()
  }

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  async populateResources() {
    this.$await.init('populateResources')

    this.activeRound = Number(await OrbitHelper.getActiveRound()) || 0

    await this.populateTransactionCountMap(
      $.walletAdapter.n3Address ?? undefined
    )

    this.$await.done('populateResources')
  }

  async populateTransactionCountMap(walletAddress?: string) {
    const tempOrbitProjectCollection = new OrbitProjectCollection()

    tempOrbitProjectCollection.round = [this.displayedRound ?? 0]

    await tempOrbitProjectCollection.queryAsPage()

    this.transactionCountMap = {}

    const promises = tempOrbitProjectCollection.items.map(async item => {
      const projectId = item.idOrbitProjectPk

      const orbitTransactionCollection = new OrbitTransactionCollection()

      orbitTransactionCollection.round = this.displayedRound
      orbitTransactionCollection.idOrbitProjectFk = projectId
      orbitTransactionCollection.limit = 1

      await orbitTransactionCollection.queryAsPage()

      const totalTransactions = String(orbitTransactionCollection.total)

      if (walletAddress) {
        orbitTransactionCollection.address = walletAddress

        await orbitTransactionCollection.queryAsPage()

        const totalYourTransactions = String(orbitTransactionCollection.total)

        this.$set(this.transactionCountMap, projectId, {
          total: totalTransactions,
          your: totalYourTransactions,
        })

        return
      }

      this.$set(this.transactionCountMap, projectId, {
        total: totalTransactions,
        your: 'N/A',
      })

      return
    })

    await Promise.all(promises)
  }

  handleRoundSelected(round: number) {
    const normalizedRound = Number(round)
    if (Number.isNaN(normalizedRound)) return

    this.displayedRound = normalizedRound
    this.displayedItems = this.orbitProjectCollection.items.filter(item => {
      const itemRound = item.orbitRound?.round
      return itemRound !== null && itemRound !== undefined
        ? Number(itemRound) === this.displayedRound
        : false
    })

    this.populateResources()
  }

  @Watch('$walletAdapter.n3Address')
  async onWalletChange() {
    await this.populateResources()
  }

  poweredByList = [
    {
      url: `/orbit`,
      alt: 'Orbit icon',
      filename: 'orbit-logo.png',
    } as PoweredByItem,
  ]
}
